module.exports = require("@ngx-translate/core");